import { useViewMeta } from 'crm-index-visualization-core/core/hooks/useViewMeta';
import { useSegment } from 'crm-index-visualization-core/core/hooks/useSegment';
import { useVizSettings } from 'crm-index-visualization-core/core/hooks/useVizSettings';
import { useVisualizationRegistry } from 'crm-index-visualization-core/core/data/VizCoreProvider';
import { useMutateVizSettings } from 'crm-index-visualization-core/core/hooks/useMutateVizSettings';
import { useCallback, useMemo } from 'react';
import { useMutateSegment } from '../hooks/useMutateSegment';
import { normalizeVizType } from '../model/vizSetting';
import { jsx as _jsx } from "react/jsx-runtime";
export function VizRenderer({
  LoadingComponent,
  ErrorComponent,
  children,
  forProvider = false,
  pageType
}) {
  var _vizRegistry$vizType;
  const vizRegistry = useVisualizationRegistry();
  const {
    data: viewMeta,
    error: viewMetaError
  } = useViewMeta();
  const {
    data: segment,
    error: segmentError
  } = useSegment();
  const vizType = useMemo(() => {
    const type = pageType !== null && pageType !== void 0 ? pageType : viewMeta === null || viewMeta === void 0 ? void 0 : viewMeta.currentViewVisualization;
    return type ? normalizeVizType(type) : undefined;
  }, [viewMeta, pageType]);
  const {
    data: vizSettings,
    error: vizSettingsError
  } = useVizSettings(vizType, {
    skip: !vizType
  });
  const [mutateSegment] = useMutateSegment();
  const onSegmentChange = useCallback(newSegment => {
    return mutateSegment(newSegment).then(__ => {});
  }, [mutateSegment]);
  const [mutateVizSettings] = useMutateVizSettings();
  const onSettingsChange = useCallback(
  // setting type is erased by React context, so we don't have type knowledge here.
  settings => {
    return !vizSettings ? Promise.resolve() : mutateVizSettings(vizSettings.with(settings)).then(__ => {});
  }, [mutateVizSettings, vizSettings]);
  if (viewMetaError || segmentError || vizSettingsError) {
    return /*#__PURE__*/_jsx(ErrorComponent, {});
  }
  if (!viewMeta || !segment || !vizSettings || !vizType) {
    return /*#__PURE__*/_jsx(LoadingComponent, {});
  }
  const Component = (_vizRegistry$vizType = vizRegistry[vizType]) === null || _vizRegistry$vizType === void 0 ? void 0 : _vizRegistry$vizType[forProvider ? 'VizProvider' : 'VizComponent'];
  if (!Component ||
  // TODO: Solve flash of wrong viz type either with debounced settings or Suspense
  vizSettings.visualizationType !== vizType) {
    return children;
  }
  return /*#__PURE__*/_jsx(Component, {
    settings: vizSettings.settings,
    segment: segment,
    onSegmentChange: onSegmentChange,
    viewMeta: viewMeta,
    onSettingsChange: onSettingsChange,
    children: children
  });
}